import React, { useContext } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const RequireAuth = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return null; // یا LoadingScreen
  }

  // اگر لودینگ تمام شده و کاربر هنوز null است
  if (!user) {
    const redirectPath = encodeURIComponent(location.pathname + location.search);
    console.warn("No user found, redirecting to auth...");
    return (
      <Navigate
        to={`/auth?redirect=${redirectPath}`}
        state={{ from: location }}
        replace
      />
    );
  }

  // منطق Onboarding
  const hasTrialData = Boolean(user?.TRIAL_START_DATE && user?.URL);
  const isOnOnboardingPage = location.pathname.includes("onboarding");

  if (!hasTrialData && !isOnOnboardingPage) {
    console.log("User has no trial data, redirecting to onboarding...");
    return <Navigate to="/" replace />;
  }

  if (hasTrialData && isOnOnboardingPage) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
